import { render } from "./authentic.vue?vue&type=template&id=ddf836fc&scoped=true"
import script from "./authentic.vue?vue&type=script&lang=js"
export * from "./authentic.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf836fc"]])

export default __exports__